// Componente Card com sombras e hover
import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg';
}

export function Card({ children, className, hover = false, padding = 'md' }: CardProps) {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={cn(
        'bg-white dark:bg-gray-900 backdrop-blur-sm rounded-xl',
        'border border-gray-200 dark:border-gray-800',
        'shadow-lg shadow-black/5 dark:shadow-black/20',
        paddingClasses[padding],
        hover && 'hover:shadow-xl hover:shadow-black/10 dark:hover:shadow-black/30 transition-all duration-200 ease-out',
        className
      )}
    >
      {children}
    </div>
  );
}
